import { ca } from '@cian/analytics';
import { useSelector } from 'react-redux';

import { selectDealType, selectOfferId } from '../../selectors/page';
import { EDealType } from '../../types/dealType';

const TRAP_TYPE_SALE = 'MyHomeEstimationReportSale';
const TRAP_TYPE_RENT = 'MyHomeEstimationReportRent';

export function useTracking() {
  const offerId = useSelector(selectOfferId);
  const dealType = useSelector(selectDealType);

  const trapType = dealType === EDealType.Sale ? TRAP_TYPE_SALE : TRAP_TYPE_RENT;

  const trackRateApartmentShow = () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'myhome',
      action: 'show_sopr',
      label: 'add_address',
      page: {
        extra: {
          trap_type: trapType,
        },
      },
      products: [
        {
          id: offerId,
          offerType: 'offer',
        },
      ],
    });
  };

  const trackRateApartmentClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'myhome',
      action: 'click',
      label: 'add_address',
      page: {
        extra: {
          trap_type: trapType,
        },
      },
      products: [
        {
          id: offerId,
          offerType: 'offer',
        },
      ],
    });
  };

  return {
    trackRateApartmentShow,
    trackRateApartmentClick,
  };
}
